import Gif from "../models/Gif";

const GifStore = Gif.create();

export default GifStore;